import React, { useState,useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import IntlMessages from "../../../utils/IntlMessages";
import { useDispatch } from "react-redux";
import Button from "@material-ui/core/Button";
import { Box, InputAdornment } from "@material-ui/core";
import { AuhMethods } from "../../../../services/auth";
import ContentLoader from "../../ContentLoader";
import { alpha, makeStyles } from "@material-ui/core/styles";
import CmtImage from "../../../../@coremat/CmtImage";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { CurrentAuthMethod } from "../../../constants/AppConstants";
import AuthWrapper from "./AuthWrapper";
import { fetchError } from "redux/actions";
import axios from "../../../../services/auth/jwt/config";

const useStyles = makeStyles((theme) => ({
  authThumb: {
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "50%",
      order: 2,
    },
  },
  authContent: {
    padding: 30,
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: (props) => (props.variant === "default" ? "50%" : "100%"),
      order: 1,
    },
    [theme.breakpoints.up("xl")]: {
      padding: 50,
    },
  },
  titleRoot: {
    marginBottom: 14,
    color: theme.palette.text.primary,
  },
  textFieldRoot: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: alpha(theme.palette.common.dark, 0.12),
    },
  },
  formcontrolLabelRoot: {
    "& .MuiFormControlLabel-label": {
      [theme.breakpoints.down("xs")]: {
        fontSize: 12,
      },
    },
  },
}));

const SignIn = ({
  method = CurrentAuthMethod,
  variant = "default",
  wrapperVariant = "default",
}) => {
  const [personalCode, setPersonalCode] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [shouldRemember, setShouldRemember] = useState(true);
  const dispatch = useDispatch();
  const [timer, setTimer] = useState(0);
  const classes = useStyles({ variant });

  const handleOtpRequest = async () => {
    try {
      await axios.post("/user/otprequestV2/admin", { nationalCode: personalCode });
      setTimer(120); 
    } catch (error) {
      if (error.response) {
        dispatch(fetchError(error.response.data.msgFa));
      } else {
        dispatch(fetchError(error.message));
      }
    }
  };

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer(t => t - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const formatTime = (secs) => {
    const m = Math.floor(secs / 60).toString().padStart(2, '0');
    const s = (secs % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };

  const onSubmit = () => {
    dispatch(
      AuhMethods[method].onLogin({ personalCode, password,otp, shouldRemember })
    );
  };

  return (
    <AuthWrapper variant={wrapperVariant}>
      {variant === "default" ? (
        <Box className={classes.authThumb}>
          <CmtImage src={"/images/auth/login-img.png"} />
        </Box>
      ) : null}
      <Box className={classes.authContent}>
        {/* <Box mb={7}>
          <CmtImage src={'/images/logo-dark.png'} />
        </Box> */}
        <Typography component="div" variant="h1" className={classes.titleRoot}>
          ورود
        </Typography>
        <form>
          <Box mb={2}>
            <TextField
              label={<IntlMessages id="appModule.personalCode" />}
              fullWidth
              onChange={(event) => setPersonalCode(event.target.value)}
              margin="normal"
              variant="outlined"
              className={classes.textFieldRoot}
            />
          </Box>
          <Box mb={2}>
            <TextField
              type="password"
              label={<IntlMessages id="appModule.password" />}
              fullWidth
              onChange={(event) => setPassword(event.target.value)}
              margin="normal"
              variant="outlined"
              className={classes.textFieldRoot}
            />
          </Box>

          <Box mb={2}>
            <TextField
              label={<IntlMessages id="appModule.otp" />}
              fullWidth
              onChange={e => setOtp(e.target.value)}
              margin="normal"
              variant="outlined"
              className={classes.textFieldRoot}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end"  disablePointerEvents={false}>
                    <Button
                      onClick={handleOtpRequest}
                      disabled={timer > 0 || !personalCode}
                      size="small"
                      variant="outlined"
                    >
                      {timer > 0 ? formatTime(timer) : <IntlMessages id="appModule.sendOtp" />}
                    </Button>
                  </InputAdornment>
                ),
              }}
            />
          </Box>


          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <FormControlLabel
              className={classes.formcontrolLabelRoot}
              control={
                <Checkbox
                  name="checkedA"
                  value={shouldRemember}
                  onChange={(e) => setShouldRemember(e.target.checked)}
                />
              }
              label={<IntlMessages id="appModule.remember" />}
            />
            {/* <Box component="p" fontSize={{ xs: 12, sm: 16 }}>
              <NavLink to="/forgot-password">
                <IntlMessages id="appModule.forgotPassword" />
              </NavLink>
            </Box> */}
            <Button onClick={onSubmit} variant="contained" color="primary">
              <IntlMessages id="appModule.signIn" />
            </Button>
          </Box>

          {/* <Box display="flex" alignItems="center" justifyContent="space-between" mb={5}>
            <Button onClick={onSubmit} variant="contained" color="primary">
              <IntlMessages id="appModule.signIn" />
            </Button>

            <Box component="p" fontSize={{ xs: 12, sm: 16 }}>
              <NavLink to="/signup">
                <IntlMessages id="signIn.signUp" />
              </NavLink>
            </Box>
          </Box> */}
        </form>

        {dispatch(AuhMethods[method].getSocialMediaIcons())}

        <ContentLoader />
      </Box>
    </AuthWrapper>
  );
};

export default SignIn;
